import React from 'react';
const SERVICE_IMAGE = 'https://autowallis.si/wp-content/uploads/2023/01/banner-mali-servis-in-cenitev-5-1024x683.jpg';
export function ServiceBanner({
  className = ''
}: {
  className?: string;
}) {
  return <article className={`relative overflow-hidden bg-aw-navy-dark ${className}`} aria-labelledby="service-banner-title" data-id="element-188" data-mp="3b8a8w1by2nz6">
      <img src={SERVICE_IMAGE} alt="Serviser pregleduje vozilo v delavnici" className="absolute inset-0 h-full w-full object-cover" data-id="element-189" data-mp="3g8xyqjofsyrt" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/20" data-id="element-190" data-mp="3p79q4nx4o0lb" />
      <div className="relative max-w-md p-8" data-id="element-191" data-mp="3u02sx691cyur">
        <h3 id="service-banner-title" className="font-heading text-xl font-bold uppercase leading-tight text-white" data-id="element-192" data-mp="3u1dwb4ykk4lc">
          Servis in cenitev vozil
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-white/75" data-id="element-193" data-mp="7pqiz5gqnu7j">
          Dober občutek je, kadar točno veste, na koga se lahko obrnete, če se zgodi najhujše.
          Prepustite nam skrb za vaše vozilo.
        </p>
        <a href="#" className="mt-6 inline-block bg-aw-accent px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white hover:text-aw-navy" data-id="element-194" data-mp="2gqgw2tfnkla4">
          Več informacij
        </a>
      </div>
    </article>;
}